import { useCallback } from 'react';

import Container from '@ui/container/container';
import GoogleMeetFiresides from '../../project-sessions-row/add-new-session/google-meet-firesides';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { saveWorkingProjectSessionByField } from '@/store/slices/project';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import { selectWorkingSession } from '@/store/slices/project/selectors';

type FiresideSettingsProps = {
  emails: TReactSelectOption<string, string>[];
};

const FiresideSettings = ({ emails }: FiresideSettingsProps) => {
  const dispatch = useAppDispatch();
  const session = useAppSelector(selectWorkingSession);

  const handleSetFiresideHosts = useCallback(
    (emails: TReactSelectOption[]) => {
      if (!session?.uuid) return;

      dispatch(
        saveWorkingProjectSessionByField({
          uuid: session.uuid,
          firesides_hosts: emails.map((email) => email.value.toString()),
        })
      );
    },
    [dispatch, session?.uuid]
  );

  return (
    <Container minHeight="82px" maxHeight="104px">
      <GoogleMeetFiresides hostEmails={emails} setHostEmails={handleSetFiresideHosts} />
    </Container>
  );
};

export default FiresideSettings;
